import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useDocumentHead } from "../hooks/useDocumentHead";
import { PLATFORM_FAVICON, captureDefaultDocumentTitle } from "./documentHead";
import { resolveAppPageTitle } from "./resolveAppPageTitle";

captureDefaultDocumentTitle();

/**
 * Platform-wide document title + favicon for routes outside client views.
 * Client views (/v/:slug) manage their own brand head.
 */
export default function AppPageHead() {
  const { pathname, search } = useLocation();
  const [hash, setHash] = useState(() =>
    typeof window !== "undefined" ? window.location.hash : ""
  );

  useEffect(() => {
    const handleHashChange = () => setHash(window.location.hash);
    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const title = resolveAppPageTitle(pathname, hash, search);
  const isClientViewRuntime =
    pathname.startsWith("/v/") &&
    !pathname.startsWith("/v/automap/dealer") &&
    !pathname.startsWith("/v/automap/admin") &&
    !pathname.startsWith("/v/automap/partner");
  const enabled = Boolean(title) && !isClientViewRuntime;

  useDocumentHead({
    title,
    favicon: PLATFORM_FAVICON,
    appleTouchIcon: PLATFORM_FAVICON,
    enabled,
    restoreTitle: false,
  });

  return null;
}
